import { SF_NEIGHBORHOODS } from "./sf-neighborhoods";
import { slugify } from "./states";

// Generic local areas/neighborhoods generated per city.
// Overrides allow real neighborhood lists for specific cities (e.g. San Francisco).
const OVERRIDES: Record<string, string[]> = {
  "california:san-francisco": SF_NEIGHBORHOODS,
};

const GENERIC = (city: string): string[] => [
  `Downtown ${city}`,
  `North ${city}`,
  `South ${city}`,
  `East ${city}`,
  `West ${city}`,
  `${city} Business District`,
  `${city} Industrial Park`,
  `${city} Midtown`,
];

export function getAreasForCity(stateSlug: string, citySlug: string, cityName: string): string[] {
  const key = `${stateSlug}:${citySlug}`;
  return OVERRIDES[key] ?? GENERIC(cityName);
}

export { slugify };
